"use strict";

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

__export(require("./booking"));

__export(require("./RoomType"));

__export(require("./SystemSetting"));

__export(require("./SystemConfig"));

__export(require("./GlobalPrice"));